import { createSlice } from "@reduxjs/toolkit";

export const eventSlice = createSlice({
  name: "event",
  initialState: {
    events: [],
    watchingEvents: [], // new state to keep track of watching events
    attendingEvents: [],
    isFetching: false,
    error: false,
  },
  reducers: {
    //GET ALL
    getEventStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    getEventSuccess: (state, action) => {
      state.isFetching = false;
      state.events = action.payload;
    },
    getEventFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    //DELETE
    deleteEventStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    deleteEventSuccess: (state, action) => {
      state.isFetching = false;
      state.events.splice(
        state.events.findIndex((item) => item._id === action.payload),
        1
      );
    },
    deleteEventFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    //UPDATE
    updateEventStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    updateEventSuccess: (state, action) => {
      state.isFetching = false;
      state.events[
        state.events.findIndex((item) => item._id === action.payload.id)
      ] = action.payload.event;
    },
    updateEventFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    //UPDATE
    addEventStart: (state) => {
      state.isFetching = true;
      state.error = false;
    },
    addEventSuccess: (state, action) => {
      state.isFetching = false;
      state.events.push(action.payload);
    },
    addEventFailure: (state) => {
      state.isFetching = false;
      state.error = true;
    },
    addEventToWatchingList: (state, action) => {
      const event = state.events.find(event => event._id === action.payload.eventId);
      if (event && !state.watchingEvents.find(watchingEvent => watchingEvent._id === event._id)) {
        state.watchingEvents.push(event);
      }
    },
    addEventToAttendingList: (state, action) => {
      const event = state.events.find(event => event._id === action.payload.eventId);
      if (event && !state.attendingEvents.find(attendingEvent => attendingEvent._id === event._id)) {
        state.attendingEvents.push(event);
      }
    },
  },
});

export const {
  getEventStart,
  getEventSuccess,
  getEventFailure,
  deleteEventStart,
  deleteEventSuccess,
  deleteEventFailure,
  updateEventStart,
  updateEventSuccess,
  updateEventFailure,
  addEventStart,
  addEventSuccess,
  addEventFailure,
  addEventToWatchingList,
  addEventToAttendingList,
} = eventSlice.actions;

export default eventSlice.reducer;
